import { registerReactComponent } from "./registerReactComponent";
import { FileManagerComponent } from "./components/FileManager/FileManagerComponent";
import { TromanDatePicker } from "./components/TromanDatePicker/TromanDatePicker";
import { TromanSelectMulti, TromanSelectSingle } from "./components/TromanSelect/TromanSelect";

registerReactComponent(FileManagerComponent, 'reactFileManager', {
    ownerId: '<',
    ownerType: '<',
});

registerReactComponent(TromanDatePicker, 'reactDatePicker', {
    date: '<',
    onChange: '<',
    minDate: '<',
    maxDate: '<',
    disabled: '<',
    isClearable: '<',
});

registerReactComponent(TromanSelectSingle, 'reactSelectSingle', {
    inputId: '<',
    tabIndex: '<',
    placeholder: '<',
    isDisabled: '<',
    options: '<',
    value: '<',
    onChange: '<',
});

registerReactComponent(TromanSelectMulti, 'reactSelectMulti', {
    inputId: '<',
    tabIndex: '<',
    placeholder: '<',
    isDisabled: '<',
    options: '<',
    value: '<',
    onChange: '<',
});